module.exports = __webpack_public_path__ + "static/img/img_gy_e_d.c949ba61.png";